<template>
  <q-form ref="form" @submit.prevent="cargar_datos">
    <div class="q-pa-md">
      <!--  <div class="q-gutter-y-md column" > -->

      <!--BOTONES -->
      <div class="square_titulo_vacio">
        <div class="square_titulo_valores_vacio" id="Div9" runat="server">
          <q-btn
            title="Crear presupuesto"
            @click="guardar_presupuesto"
            class="ma-2 buttonoscuro"
            >Crear</q-btn
          >
        </div>
        <div class="square_titulo_valores_vacio" id="Div9" runat="server">
          <q-icon name="info" />* Datos obligatorios
        </div>
      </div>
      <!--DATOS GENERALES -->
      <div class="q-pa-md row items-start">
        <q-card class="my-card">
          <q-card-section class="card_titulo">
            <div class="card_titulo_text">Datos generales</div>
          </q-card-section>
          <q-card-actions align="around">
            <!-- CAMPO  nombre actuación -->
            <div class="flex-container">
              <div class="flex-item_50">
                <q-field borderless ref="field" :value="nombre_actuacion">
                  <q-input
                    v-model="$v.nombre_actuacion.$model"
                    maxlength="100"
                    options-dense
                    input-debounce="0"
                    @change="clearSpace"
                    type="N"
                    :error="$v.nombre_actuacion.$error"
                    label="*Nombre actuación"
                    class="col-12"
                    :rules="[(val) => !!val || 'Dato obligatorio']"
                  >
                    <template v-slot:error>Dato obligatorio.</template>
                  </q-input>
                </q-field>
              </div>
              <!-- CAMPO  provincia -->

              <div class="flex-item_20">
                <q-field borderless ref="field" :value="provincia">
                  <q-select
                    v-model="$v.provincia.$model"
                    label="*Provincia"
                    use-input
                    emit-value
                    map-options
                    clearable
                    input-debounce="0"
                    options-dense
                    style="width: 120%"
                    option-value="Id"
                    option-label="Nombre"
                    :error="$v.provincia.$error"
                    :rules="[(val) => !!val || 'Dato Obligatorio']"
                    :options="datos_provincias"
                    @filter="filterFnProvincias"
                  >
                    <template v-slot:error>Dato obligatorio.</template>
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section>Sin datos</q-item-section>
                      </q-item>
                    </template>
                  </q-select>
                </q-field>
              </div>

              <!-- CAMPO  municipio -->
              <div class="flex-item_40">
                <q-field borderless ref="field" :value="municipio">
                  <q-select
                    v-model="$v.municipio.$model"
                    label="*Municipio"
                    use-input
                    emit-value
                    map-options
                    options-dense
                    clearable
                    style="width: 120%"
                    option-value="Id"
                    option-label="Nombre"
                    :error="$v.municipio.$error"
                    :rules="[(val) => !!val || 'Dato Obligatorio']"
                    :options="datos_municipios"
                    @filter="filterFnMunicipios"
                  >
                    <template v-slot:error>Dato obligatorio.</template>
                  </q-select>
                </q-field>
              </div>
            </div>
          </q-card-actions>
        </q-card>
      </div>

      <!--DATOS DECISION-->
      <div class="q-pa-md row items-start">
        <q-card class="my-card-datos-decision">
          <q-card-section class="card_titulo">
            <div class="card_titulo_text">Toma de decisión</div>
          </q-card-section>
          <q-card-actions align="around">
            <div class="flex-container-datos-decision">
              <!-- CAMPO  servicio -->
              <div class="flex-item_10">
                <q-field borderless ref="field" :value="servicio">
                  <template v-slot:control>
                    <q-select
                      v-model="$v.servicio.$model"
                      label="*Servicio"
                      emit-value
                      map-options
                      options-dense
                      style="width: 100%"
                      option-value="Id"
                      option-label="Nombre"
                      :error="$v.servicio.$error"
                      :rules="[(val) => !!val || 'Dato Obligatorio']"
                      :options="datos_servicios"
                    >
                      <template v-slot:error>Dato obligatorio.</template>
                      <template v-slot:no-option>
                        <q-item>
                          <q-item-section>Sin datos</q-item-section>
                        </q-item>
                      </template>
                    </q-select>
                  </template>
                </q-field>
              </div>
              <!-- CAMPO  Actuacion -->

              <div class="flex-item_10">
                <q-field borderless ref="field" :value="actuacion">
                  <template v-slot:control>
                    <q-select
                      v-model="$v.actuacion.$model"
                      label="*Actuación"
                      emit-value
                      map-options
                      options-dense
                      style="width: 100%"
                      option-value="Id"
                      option-label="Nombre"
                      :error="$v.actuacion.$error"
                      :rules="[(val) => !!val || 'Dato Obligatorio']"
                      :options="datos_actuaciones"
                    >
                      <template v-slot:error>Dato obligatorio.</template>
                      <template v-slot:no-option>
                        <q-item>
                          <q-item-section>Sin datos</q-item-section>
                        </q-item>
                      </template>
                    </q-select>
                  </template>
                </q-field>
              </div>

              <!-- CAMPO  Problema -->
              <div class="flex-item_30">
                <q-field borderless ref="field" :value="problema">
                  <template v-slot:control>
                    <q-select
                      v-model="$v.problema.$model"
                      label="*Problema"
                      emit-value
                      map-options
                      options-dense
                      style="width: 100%"
                      option-value="Id"
                      option-label="Descripcion"
                      :error="$v.problema.$error"
                      :rules="[(val) => !!val || 'Dato Obligatorio']"
                      :options="datos_problemas"
                    >
                      <template v-slot:error>Dato obligatorio.</template>
                      <template v-slot:no-option>
                        <q-item>
                          <q-item-section>Sin datos</q-item-section>
                        </q-item>
                      </template>
                    </q-select>
                  </template>
                </q-field>
              </div>
              <div class="flex-item_20">
                <q-item-label>Tecnología óptima</q-item-label>
                <q-item-label class="text_Tecnologia">{{
                  tecnologia
                }}</q-item-label>
              </div>
              <div class="flex-item_5">
                <q-btn
                  @click="abrir_ficha_tecnologia"
                  :class="['text_btn_presupuesto_peq', disable_tramos ? 'buttonoscurodisabled' : 'buttonoscuro']"
                  disabled
                  >Ver ficha tecnología</q-btn>
                  <!-- :disable="disable_tramos" -->
              </div>
            </div>
          </q-card-actions>
        </q-card>
      </div>
      <!--DATOS ACTUACION -->
      <div class="q-pa-md row items-start">
        <q-card class="my-card">
          <q-card-section class="card_titulo">
            <div class="card_titulo_text">Datos actuación</div>
          </q-card-section>
          <q-card-actions align="around">
            <div class="flex-item_11">
              <q-toggle
                color="blue"
                label="Nivel freático"
                v-model="nivel_freatico"
                val="blue"
              />
            </div>
            <div class="flex-item_5">
              <q-toggle
                color="blue"
                label="Tráfico"
                v-model="trafico"
                val="blue"
              />
            </div>
            <div class="flex-item_11">
              <q-field borderless ref="field" :value="material">
                <q-select
                  v-model="$v.material.$model"
                  label="*Material"
                  emit-value
                  map-options
                  options-dense
                  clearable
                  style="width: 100%"
                  option-value="Id"
                  option-label="Nombre"
                  :error="$v.material.$error"
                  :rules="[(val) => !!val || 'Dato Obligatorio']"
                  :options="datos_material"
                >
                  <template v-slot:error>Dato obligatorio.</template>
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section>Sin datos</q-item-section>
                    </q-item>
                  </template>
                </q-select>
              </q-field>
            </div>
            <div class="flex-item_11">
              <q-field borderless ref="field" :value="terreno">
                <q-select
                  v-model="$v.terreno.$model"
                  label="*Terreno"
                  emit-value
                  map-options
                  options-dense
                  clearable
                  style="width: 100%"
                  option-value="Id"
                  option-label="Nombre"
                  :error="$v.terreno.$error"
                  :rules="[(val) => !!val || 'Dato Obligatorio']"
                  :options="datos_terreno"
                >
                  <template v-slot:error>Dato obligatorio.</template>
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section>Sin datos</q-item-section>
                    </q-item>
                  </template>
                </q-select>
              </q-field>
            </div>
            <div class="flex-item_11">
              <q-field borderless ref="field" :value="pavimento">
                <q-select
                  v-model="$v.pavimento.$model"
                  label="*Pavimento"
                  emit-value
                  map-options
                  options-dense
                  clearable
                  style="width: 100%"
                  option-value="Id"
                  option-label="Nombre"
                  :error="$v.pavimento.$error"
                  :rules="[(val) => !!val || 'Dato Obligatorio']"
                  :options="datos_pavimento"
                >
                  <template v-slot:error>Dato obligatorio.</template>
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section>Sin datos</q-item-section>
                    </q-item>
                  </template>
                </q-select>
              </q-field>
            </div>
            <div class="flex-item_11">
              <q-field borderless ref="field" :value="profundidad_media">
                <q-input
                  v-model="$v.profundidad_media.$model"
                  input-debounce="0"
                  step="0.01"
                  min="0.01"
                  required
                  label="*Profundidad media (m)"
                  class="col-12"
                  :error="$v.profundidad_media.$error"
                  :rules="[
                    (val) =>
                      /^[0-9]+([.,][0-9]+)?$/.test(val) || 'Dato Decimal',
                  ]"
                >
                  <template v-slot:error>Dato obligatorio.</template>
                </q-input>
              </q-field>
            </div>
            <div class="flex-item_11">
              <q-field borderless ref="field" :value="acometida">
                <q-input
                  v-model="$v.acometida.$model"
                  type="number"
                  min="0"
                  input-debounce="0"
                  required
                  :error="$v.acometida.$error"
                  :rules="[(val) => !!/^([0-9])*$/.test(val) || 'Dato Entero']"
                  label="*Acometida"
                  class="col-12"
                >
                  <template v-slot:error>Dato obligatorio.</template>
                </q-input>
              </q-field>
            </div>
            <div class="flex-item_11">
              <q-field borderless ref="field" :value="pozo_registro">
                <q-input
                  v-model="pozo_registro"
                  type="number"
                  min="1"
                  required
                  :disable="this.isSaneamiento"
                  input-debounce="0"
                  :rules="[
                    (val) => !!/^([0-9])*$/.test(val) || 'Dato Entero',
                    (val) => val > 0 || 'Dato Entero >0 ',
                  ]"
                  label="*Pozos de registro"
                  class="col-12"
                >
                </q-input>
              </q-field>
            </div>
            <div class="flex-item_11">
              <q-field borderless ref="field" :value="incidencias">
                <q-input
                  v-model="$v.incidencias.$model"
                  type="number"
                  min="0"
                  input-debounce="0"
                  required
                  :error="$v.incidencias.$error"
                  :rules="[(val) => !!/^([0-9])*$/.test(val) || 'Dato Entero']"
                  label="*Servicios afectados"
                  class="col-12"
                >
                  <template v-slot:error>Dato obligatorio.</template>
                </q-input>
              </q-field>
            </div>
          </q-card-actions>
        </q-card>
      </div>

      <!--DATOS TRAMOS -->
      <div class="q-pa-md row items-start">
        <q-card class="my-card-datos-actuacion">
          <q-card-section class="card_titulo">
            <div class="card_titulo_text">Definición de tramos</div>
          </q-card-section>
          <q-card-actions align="around">
            <div class="flex-item_10">
              <q-input
                v-model="longitud"
                step="0.01"
                min="0.01"
                label="*Longitud (m)"
                style="width: 100%"
                required
                :disable="disable_tramos"
                :rules="[
                  (val) => /^[0-9]+([.,][0-9]+)?$/.test(val) || 'Dato Decimal',
                  (val) => val != '' || 'Dato Decimal',
                ]"
              />
            </div>
            <!-- CAMPO  Diámetro -->

            <div class="flex-item_10">
              <q-field borderless ref="field" :value="diametro">
                <q-select
                  :disable="disable_tramos"
                  v-model="diametro"
                  label="*Diámetro (mm)"
                  emit-value
                  map-options
                  clearable
                  options-dense
                  style="width: 100%"
                  option-value="Id"
                  option-label="Valor"
                  :options="datos_diametro"
                >
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section>Sin datos</q-item-section>
                    </q-item>
                  </template>
                </q-select>
              </q-field>
            </div>

            <div class="flex-item_10">
              <q-btn
                @click="cargar_tramo"
                :disable="disable_tramos"
                :class="['ma-2', disable_tramos ? 'buttonoscurodisabled' : 'buttonoscuro']"
                >Añadir tramo</q-btn
              >
            </div>
            <div class="flex-item_50">
              <q-table
                :data="datos_tramos"
                :columns="columns"
                dense
                no-data-label="Sin datos"
                style="width: 100%"
              >
                <template v-slot:body="props">
                  <q-tr :props="props">
                    <q-td key="Longitud" :props="props" style="width: 30%">{{
                      props.row.datotramo_Longitud
                    }}</q-td>
                    <q-td key="Diametro" :props="props" style="width: 30%">{{
                      props.row.datotramo_Diametro
                    }}</q-td>
                    <q-td key="actions" :props="props">
                      <q-chip
                        clickable
                        @click="eliminar_tramo(props.row)"
                        color="primary"
                        text-color="white"
                        class="text_btn_presupuesto_mini"
                        >Eliminar</q-chip
                      >
                      <!--  <q-btn color="lime" label="Eliminar"  @click="eliminar_tramo(props.row)" class="text_btn_presupuesto_peq"  size=sm no-caps></q-btn> -->
                    </q-td>
                  </q-tr>
                </template>
              </q-table>
            </div>
            <div class="flex-item_100">
              <div class="flex-item_100">
                <q-icon name="info" />
                <span
                  >En caso de que la longitud de la conducción sea superior a
                  180 metros, haya un cambio de diámetro o de dirección, se
                  recomienda definir tramos diferentes, en caso contrario podría
                  producirse una desviación en el presupuesto generado.</span
                >
              </div>
              <div class="flex-item_100">
                <q-icon name="info" />
                <span
                  >En caso de que el sistema haya determinado como tecnología
                  Packers, la longitud de tramo será la del número de Packers a
                  instalar (2m/unidad).</span
                >
              </div>
            </div>
          </q-card-actions>
        </q-card>
      </div>
    </div>

    <cargando :contenido_mensaje="mensaje_cargando" />

    <!--ALERT CUADRO DE DIÁLOGO-->
    <q-dialog v-model="alert_tramos">
      <q-card>
        <q-card-section>
          <div class="text-h6">Aviso:</div>
        </q-card-section>
        <q-card-section class="q-pt-none" style="white-space: pre-line">{{
          mensaje_alert
        }}</q-card-section>
        <q-card-actions align="right">
          <q-btn
            flat
            label="OK"
            color="primary"
            @click="reiniciar_mensaje"
            v-close-popup
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-form>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import Cargando from '@/components/shared/components/Cargando';
import { Loading, QSpinnerGears, Notify } from 'quasar';
import { Cookies } from 'quasar';
import {
  QInput,
  QSelect,
  QCard,
  QList,
  QField,
  QItem,
  QItemSection,
  QItemLabel,
  QCardSection,
  QCardActions,
  QBtnToggle,
  QCheckbox,
  QTable,
  QTh,
  QTr,
  QTd,
  QToggle,
  ClosePopup,
  QDialog,
  Quasar
} from 'quasar';

export default {
  ocultar_actuacion: Boolean,
  ocultar_problema: Boolean,

  mounted () {
    this.cargar_datos();
  },

  methods: {
    clearSpace () {
      let nombre_actuacion = this.nombre_actuacion;

      this.nombre_actuacion = nombre_actuacion.trimStart().trimEnd();
    },
    abrir_ficha_tecnologia () {
      window.open(this.url, '_blank');
    },

    comprobar_datos_generales () {
      if (
        this.nombre_actuacion.trim() === '' ||
        this.nombre_actuacion.length === 0 ||
        this.provincia === null ||
        this.provincia.length === 0 ||
        this.provincia === '' ||
        this.municipio === null ||
        this.municipio === '' ||
        this.municipio.length === 0
      ) {
        return false;
      } else return true;
    },

    comprobar_datos_decision () {
      if (
        this.servicio === null ||
        this.servicio === '' ||
        this.actuacion === null ||
        this.actuacion === '' ||
        this.problema === null ||
        this.problema === ''
      ) {
        return false;
      } else return true;
    },

    comprobar_datos_tramos () {
      if (this.datos_tramos.length === 0) return false;
      else return true;
    },

    comprobar_datos_actuacion () {
      // Se comprueba si es "Saneamiento"
      if (this.servicio == '2') {
        if (
          this.material === null ||
          this.material.length === 0 ||
          this.terreno === null ||
          this.terreno.length === 0 ||
          this.pavimento === null ||
          this.pavimento.length === 0 ||
          this.profundidad_media === null ||
          this.profundidad_media.length === 0 ||
          // this.acometida === null ||
          // this.acometida < 0 ||
          // this.acometida.length === 0 ||
          this.incidencias === null ||
          this.incidencias.length === 0 ||
          this.incidencias < 0 ||
          this.pozo_registro === null ||
          this.pozo_registro.length === 0 ||
          this.pozo_registro <= 0
        ) {
          return false;
        } else {
          if (
            this.tecnologia == 'Sombreretes' &&
            (this.acometida === null ||
              this.acometida < 1 ||
              this.acometida.length === 0)
          ) {
            this.mensaje_alert =
              "- En la tecnología Sombreretes debe haber al menos una acometida en 'Datos actuación'\n";
            return false;
          } else {
            return true;
          }
        }
      } else {
        if (
          this.material === null ||
          this.material === '' ||
          this.terreno === null ||
          this.terreno === '' ||
          this.pavimento === null ||
          this.pavimento === '' ||
          this.profundidad_media === null ||
          this.profundidad_media.length === 0 ||
          // this.acometida === null ||
          // this.acometida < 0 ||
          // this.acometida.length === 0 ||
          this.incidencias === null ||
          this.incidencias < 0 ||
          this.incidencias.length === 0
        ) {
          return false;
        } else return true;
      }
    },

    loading_mensaje () {
      this.isLoading = false;
      this.$store.commit('TSZ/setOffline', false);
    },

    redirigir_a_comparativa (id) {
      this.$store.commit('TSZ/setIdComparativa', id);

      setTimeout(this.loading_mensaje, 15000);
      this.$router.push({
        name: 'Comparativa',
        path: '/Comparativa',
        component: () =>
          import('@/components/Comparativa/views/TSZ_Comparativas.vue'),
        params: { PresupuestoId: id }
      });
    },

    mostrar_mensaje (mensaje, color, timeout = 5000) {
      this.showError(mensaje, color, timeout);
      /* this.mensaje_alert = mensaje;
      this.alert_tramos = true; */
    },

    reiniciar_mensaje () {
      this.mensaje_alert = '';
    },

    guardar_presupuesto () {
      this.$v.$touch();

      var mensaje_guardar = '';
      var mensaje = '';
      if (!this.comprobar_datos_generales()) {
        mensaje_guardar = "- 'Datos generales'\n";
      }
      if (!this.comprobar_datos_decision()) {
        mensaje_guardar = mensaje_guardar + "- 'Datos de decisión'\n";
      }
      if (!this.comprobar_datos_actuacion()) {
        if (this.mensaje_alert != '') {
          mensaje_guardar = mensaje_guardar + this.mensaje_alert;
          this.mensaje_alert = '';
        } else mensaje_guardar = mensaje_guardar + "- 'Datos actuación'\n";
      }
      if (!this.comprobar_datos_tramos()) {
        mensaje_guardar = mensaje_guardar + "- 'Definición de tramos'\n";
      }
      if (mensaje_guardar == '') {
        this.isLoading = true;
        this.$store.commit('TSZ/setOffline', true);

        this.Datos_Generales.Email = this.$store.getters['TSZ/userMail'];
        this.Datos_Generales.Aplicacion = process.env.VUE_APP_ID;

        this.Datos_Generales.Nombre = this.nombre_actuacion;
        this.Datos_Generales.ProvinciaId = this.provincia;
        this.Datos_Generales.MunicipioId = this.municipio;

        this.Datos_Decision.ServicioId = this.servicio;
        this.Datos_Decision.ActuacionId = this.actuacion;
        this.Datos_Decision.ProblemaId = this.problema;

        this.Datos_Generales.NivelFreatico = this.nivel_freatico;
        this.Datos_Generales.Trafico = this.trafico;
        this.Datos_Generales.MaterialId = this.material;
        this.Datos_Generales.TerrenoId = this.terreno;
        this.Datos_Generales.PavimentoId = this.pavimento;
        this.Datos_Generales.ProfundidadMedia = this.profundidad_media.replace(
          ',',
          '.'
        );
        this.Datos_Generales.Acometidas = this.acometida;
        this.Datos_Generales.PozosRegistro = this.pozo_registro;
        this.Datos_Generales.Incidencias = this.incidencias;

        this.$store.commit('TSZ/setDatosGenerales', this.Datos_Generales);
        this.$store.commit('TSZ/setDatosDecision', this.Datos_Decision);
        this.$store.commit('TSZ/setDatosTramos', this.Datos_Tramo);

        let currentObj = this;
        this.$store
          .dispatch('TSZ/postDatosPresupuesto')
          .then((response) => {
            if (process.env.VUE_APP_ACCESO_ADMIN === '1') {
              this.redirigir_a_comparativa(response.data.Data.Id);
            } else {
              this.mostrar_mensaje(
                'Presupuesto guardado correctamente',
                'green'
              );
            }
          })

          .catch((err) => {
            this.$store.commit('TSZ/setOffline', false);
            mensaje = 'Se ha producido un error: ' + err.response.data;
            this.mostrar_mensaje(mensaje);
          });
      } else {
        mensaje =
          'Datos incompletos, hay que introducir datos correctamente en:\n' +
          mensaje_guardar;
        this.mostrar_mensaje(mensaje, 'red');
      }
    },

    eliminar_tramo (tramo) {
      const index = this.datos_tramos.indexOf(tramo);

      this.datos_tramos.splice(index, 1);
      // Se comprueba si se puede eliminar el bloqueo
      if (this.datos_tramos.length === 0) {
        this.disable_tramos = false;
      }
      this.Datos_Tramo.splice(index, 1);
      // Se comprueba si se puede eliminar el bloqueo
      if (this.Datos_Tramo.length === 0) {
        this.disable_tramos = false;
      }
    },

    /*  Obtención de datos..... */

    init () {
      this.cargar_datos();
    },

    filtrar () {
      if (this.provincia != '') {
        this.cargar_datos_municipios();
      }
    },

    cargar_tramo () {
      var valor_diametro;
      var valor_Id;
      var valor_longitud;
      this.mensaje_alert = '';

      this.longitud = this.longitud.replace(',', '.');

      if (this.tecnologia.length > 5) {
        if (
          (this.longitud === null ||
            this.longitud === '' ||
            this.longitud <= 0) &&
          this.diametro === null
        ) {
          this.mensaje_alert =
            'Tramo incorrecto: debe introducir una longitud>0 y seleccionar un diámetro';
        } else {
          valor_longitud = parseFloat(this.longitud);

          if (
            valor_longitud != this.longitud ||
            this.longitud <= 0 ||
            !/^[0-9]+([.,][0-9]+)?$/.test(this.longitud)
          ) {
            this.mensaje_alert =
              'Tramo incorrecto: debe introducir una longitud > 0';
          } else if (this.tecnologia == 'Packers' && this.longitud % 2 != 0) {
            this.mensaje_alert =
              'Tramo incorrecto para la tecnología Packer: debe introducir una longitud par';
          }
          if (this.diametro === null) {
            this.mensaje_alert = 'Tramo incorrecto: seleccione un diámetro';
          }
        }
        if (this.mensaje_alert != '') {
          this.mostrar_mensaje(this.mensaje_alert, 'red');
        } else {
          // INTRODUCCIÓN DE TRAMOS...
          // INTRODUCIENDO TRAMOS
          for (var i = 0, i_len = this.datos_diametro.length; i < i_len; i++) {
            if (this.diametro === this.datos_diametro[i].Id) {
              valor_diametro = this.datos_diametro[i].Valor;
            }
          }
          valor_Id = this.datos_tramos.length + 1;
          /* console.log(
                  "Tramo valor_Id: " +
                    valor_Id +
                    " " +
                    parseFloat(this.longitud) +
                    " " +
                    this.longitud +
                    " " +
                    valor_diametro
                ); */
          this.datos_tramos.push({
            datotramo_Id: valor_Id,
            datotramo_Longitud: this.longitud,
            datotramo_Diametro: valor_diametro,
            datotramo_DiametroId: this.diametro
          });
          this.Datos_Tramo.push({
            DiametroId: this.diametro,
            Longitud: this.longitud,
            Id: 0
          });
          this.onReset();
          // FIN Introduciendo tramos......
          if (this.multitramo === true) this.disable_tramos = false;
          else this.disable_tramos = true;
        }
      }
    },

    cargar_datos () {
      this.cargar_acceso_admin();
      this.cargar_datos_provincias();
      this.cargar_datos_servicios();
      this.cargar_datos_actuaciones();

      this.cargar_datos_material();
      this.cargar_datos_terreno();
      this.cargar_datos_pavimento();

      this.isLoading = false;
      this.$store.commit('TSZ/setOffline', false);
      this.mensaje_cargando = 'Generando presupuesto';
    },

    cargar_acceso_admin () {
      this.isAdmin = this.$store.getters['TSZ/CargaAccesoAdmin'];
    },

    cargar_datos_material () {
      let request = {
        controller: 'Configuracion/Materiales',
        filter: {}
      };

      this.$store
        .dispatch('TSZ/getDatosTSZ', request)
        .then((response) => {
          this.datos_material = response.data.Data;
        })
        .catch((err) => {
          console.log('error_API');
          this.showError(err);
          this.isLoadingDatos = false;
        });
    },

    cargar_datos_terreno () {
      let request = {
        controller: 'Configuracion/Terrenos',
        filter: {}
      };

      this.$store
        .dispatch('TSZ/getDatosTSZ', request)
        .then((response) => {
          this.datos_terreno = response.data.Data;
        })
        .catch((err) => {
          console.log('error_API');
          this.showError(err);
          this.isLoadingDatos = false;
        });
    },

    cargar_datos_pavimento () {
      let request = {
        controller: 'Configuracion/Pavimentos',
        filter: {}
      };

      this.$store
        .dispatch('TSZ/getDatosTSZ', request)
        .then((response) => {
          this.datos_pavimento = response.data.Data;
        })
        .catch((err) => {
          console.log('error_API');
          this.showError(err);
          this.isLoadingDatos = false;
        });
    },

    cargar_datos_provincias () {
      this.datos_municipios = [];
      let request = {
        controller: 'Localizacion/Provincias',
        filter: {}
      };

      this.$store
        .dispatch('TSZ/getDatosTSZ', request)
        .then((response) => {
          this.datos_provincias = response.data.Data;
          this.datos_provinciasSelect = response.data.Data;
        })
        .catch((err) => {
          console.log('error_API');
          this.showError(err);
          this.isLoadingDatos = false;
        });
    },

    cargar_datos_servicios () {
      this.datos_problemas = [];
      let request = {
        controller: 'Configuracion/Servicios',
        filter: {}
      };

      this.$store
        .dispatch('TSZ/getDatosTSZ', request)
        .then((response) => {
          this.datos_servicios = response.data.Data;
        })
        .catch((err) => {
          console.log('error_API');
          this.showError(err);
          this.isLoadingDatos = false;
        });
    },

    cargar_datos_actuaciones () {
      this.datos_problemas = [];

      let request = {
        controller: 'Configuracion/Actuaciones',
        filter: {}
      };

      this.$store
        .dispatch('TSZ/getDatosTSZ', request)
        .then((response) => {
          this.datos_actuaciones = response.data.Data;
        })
        .catch((err) => {
          console.log('error_API');
          this.showError(err);
          this.isLoadingDatos = false;
        });
    },

    cargar_datos_diametro () {
      this.longitud = null;
      this.datos_tramos = [];
      this.diametro = null;

      switch (this.tecnologia) {
        case 'Packers':
          this.datos_diametro = [
            { Valor: 200, Id: 3 },
            { Valor: 250, Id: 5 },
            { Valor: 300, Id: 6 },
            { Valor: 350, Id: 7 },
            { Valor: 400, Id: 9 },
            { Valor: 500, Id: 11 },
            { Valor: 600, Id: 12 },
            { Valor: 700, Id: 14 },
            { Valor: 800, Id: 16 }
          ];
          break;
        case 'Manga UVA':
          this.datos_diametro = [
            { Valor: 150, Id: 2 },
            { Valor: 200, Id: 3 },
            { Valor: 250, Id: 5 },
            { Valor: 300, Id: 6 },
            { Valor: 350, Id: 7 },
            { Valor: 400, Id: 9 },
            { Valor: 450, Id: 10 },
            { Valor: 500, Id: 11 },
            { Valor: 600, Id: 12 },
            { Valor: 700, Id: 14 },
            { Valor: 800, Id: 16 },
            { Valor: 900, Id: 17 },
            { Valor: 1000, Id: 18 },
            { Valor: 1100, Id: 19 },
            { Valor: 1200, Id: 20 }
          ];
          break;
        case 'Manga EPOXY':
          this.datos_diametro = [
            { Valor: 150, Id: 2 },
            { Valor: 200, Id: 3 },
            { Valor: 250, Id: 5 },
            { Valor: 300, Id: 6 },
            { Valor: 350, Id: 7 },
            { Valor: 400, Id: 9 },
            { Valor: 450, Id: 10 },
            { Valor: 500, Id: 11 },
            { Valor: 600, Id: 12 },
            { Valor: 700, Id: 14 },
            { Valor: 800, Id: 16 }
          ];
          break;
        case 'Manga UVA H2O':
          this.datos_diametro = [
            { Valor: 200, Id: 3 },
            { Valor: 250, Id: 5 },
            { Valor: 300, Id: 6 },
            { Valor: 350, Id: 7 },
            { Valor: 400, Id: 9 },
            { Valor: 450, Id: 10 },
            { Valor: 500, Id: 11 },
            { Valor: 600, Id: 12 },
            { Valor: 700, Id: 14 },
            { Valor: 800, Id: 16 },
            { Valor: 1000, Id: 18 }
          ];
          break;
        case 'Spray Lining':
          this.datos_diametro = [
            { Valor: 150, Id: 2 },
            { Valor: 200, Id: 3 },
            { Valor: 250, Id: 5 },
            { Valor: 300, Id: 6 },
            { Valor: 350, Id: 7 },
            { Valor: 400, Id: 9 },
            { Valor: 450, Id: 10 },
            { Valor: 500, Id: 11 },
            { Valor: 600, Id: 12 }
          ];
          break;
        default: {
          let request = {
            controller: 'Configuracion/Diametros',
            filter: {}
          };
          this.$store
            .dispatch('TSZ/getDatosTSZ', request)
            .then((response) => {
              this.datos_diametro = response.data.Data;
            })
            .catch((err) => {
              console.log('error_API');
              this.showError(err);
              this.isLoadingDatos = false;
            });
          break;
        }
      }
    },

    cargar_datos_ (tipo) {
      log.console(',,,,,' + tipo);
      let request = {
        controller: tipo,
        filter: {}
      };
      this.$store
        .dispatch('TSZ/getDatosTSZ', request)
        .then((response) => {
          return response.data.Data;
        })
        .catch((err) => {
          console.log('error_API');
          this.showError(err);
          this.isLoadingDatos = false;
        });
    },

    cambiar_tecnologia () {
      this.tecnologia = '';

      this.disable_tramos = true;
      this.datos_tramos = [];
      this.datos_diametros = [];
      this.longitud = null;
      this.diametro = null;
    },

    reset () {},

    loadData () {},

    filterFnProvincias (val, update, abort) {
      update(() => {
        const needle = val.toLowerCase();
        this.datos_provincias = this.datos_provinciasSelect.filter(
          (v) => v.Nombre.toLowerCase().indexOf(needle) > -1
        );
      });
    },
    filterFnMunicipios (val, update, abort) {
      update(() => {
        const needle = val.toLowerCase();
        this.datos_municipios = this.datos_municipiosSelect.filter(
          (v) => v.Nombre.toLowerCase().indexOf(needle) > -1
        );
      });
    },

    getDatosServicio (watchVariable) {
      // Se comprueba si es "Saneamiento" para habilitar pozos de registro
      if (this.servicio == '2') this.isSaneamiento = false;
      else {
        this.isSaneamiento = true;
        this.pozo_registro = null;
      }
      // Cargar Servicios....
      if (this.servicio != null && this.actuacion != null) {
        let request = {
          controller: 'Configuracion/Servicios',
          filter: {}
        };
        this.$store
          .dispatch('TSZ/getDatosTSZ', request)
          .then((response) => {
            this.datos_servicios = response.data.Data;

            // Cargar Problemas
            let request = {
              controller: 'Configuracion/Problemas',
              filter: {},
              data: {
                servicioId: this.servicio,
                actuacionId: this.actuacion
              }
            };
            this.$store
              .dispatch('TSZ/getDatosTSZ', request)
              .then((response) => {
                this.datos_problemas = response.data.Data;
                this.problema = null;
                this.cambiar_tecnologia();
              })
              .catch((err) => {
                this.showError(err);
                this.isLoadingDatos = false;
              });
            // Fin Cargar municipios
          })
          .catch((err) => {
            this.showError(err);
            this.isLoadingDatos = false;
          });
      }
    },

    getDatosActuacion (watchVariable) {
      // Cargar Actuaciones....
      if (this.servicio != null && this.actuacion != null) {
        let request = {
          controller: 'Configuracion/Actuaciones',
          filter: {}
        };
        this.$store
          .dispatch('TSZ/getDatosTSZ', request)
          .then((response) => {
            this.datos_actuaciones = response.data.Data;
            // Cargar Problemas
            let request = {
              controller: 'Configuracion/Problemas',
              filter: {},
              data: {
                servicioId: this.servicio,
                actuacionId: this.actuacion
              }
            };
            this.$store
              .dispatch('TSZ/getDatosTSZ', request)
              .then((response) => {
                this.datos_problemas = response.data.Data;
                this.problema = null;
                this.cambiar_tecnologia();
              })
              .catch((err) => {
                this.showError(err);
                this.isLoadingDatos = false;
              });
            // Fin Cargar Problemas
          })
          .catch((err) => {
            this.showError(err);
            this.isLoadingDatos = false;
          });
      }
    },

    getDatosMunicipio (watchVariable) {
      // Cargar provincias....
      this.datos_municipios = [];
      let request = {
        controller: 'Localizacion/Provincias',
        filter: {}
      };
      this.$store
        .dispatch('TSZ/getDatosTSZ', request)
        .then((response) => {
          this.datos_provincias = response.data.Data;
          // Cargar municipios
          let request = {
            controller: 'Localizacion/Municipios/' + this.provincia,
            filter: {}
          };
          this.$store
            .dispatch('TSZ/getDatosTSZ', request)
            .then((response) => {
              this.datos_municipios = response.data.Data;
              this.datos_municipiosSelect = response.data.Data;
            })
            .catch((err) => {
              console.log('error_API');
              this.showError(err);
              this.isLoadingDatos = false;
            });
          // Fin Cargar municipios
        })
        .catch((err) => {
          this.showError(err);
          this.isLoadingDatos = false;
        });
    },

    getDatosTecnologia () {
      if (this.servicio != null && this.actuacion != null) {
        let request = {
          controller: 'Configuracion/Problemas',
          filter: {},
          data: {
            servicioId: this.servicio,
            actuacionId: this.actuacion
          }
        };
        this.$store
          .dispatch('TSZ/getDatosTSZ', request)
          .then((response) => {
            this.datos_problemas = response.data.Data;
            if (this.problema != null) {
              for (
                var i = 0, i_len = response.data.Data.length;
                i < i_len;
                i++
              ) {
                if (this.problema === response.data.Data[i].Id) {
                  this.tecnologia = response.data.Data[i].NombreTecnologia;
                  this.multitramo = response.data.Data[i].Multitramo;
                  this.disable_tramos = false;
                  this.url = response.data.Data[i].Url;

                  /* if (this.tecnologia == "Sombreretes") {
                    this.isSombreretes = false;
                  } else {
                    this.isSombreretes = true;
                    this.acometida = "";
                  } */
                  this.cargar_datos_diametro();
                }
              }
            } else {
              this.cambiar_tecnologia();
            }
          })
          .catch((err) => {
            this.showError(err);
            this.isLoadingDatos = false;
          });
      }
    },
    onReset () {
      this.longitud = null;
      this.diametro = null;
    },
    showError (text, color = 'red', timeout) {
      this.$q.notify({
        message: text,
        color: color,
        icon: 'warning',
        timeout: timeout,
        position: 'top-right',
        progress: true,
        actions: [{ icon: 'close', color: 'white' }]
      });
    }
  },

  watch: {
    provincia: {
      handler: function () {
        (this.municipio = []), this.getDatosMunicipio('provincia');
      },
      deep: false
    },

    servicio: {
      handler: function () {
        (this.problema = null), this.getDatosServicio('servicio');
      },
      deep: false
    },

    actuacion: {
      handler: function () {
        (this.problema = null), this.getDatosActuacion('actuacion');
      },
      deep: false
    },

    problema: {
      handler: function () {
        this.getDatosTecnologia();
      },
      deep: false
    }
  },

  computed: {
    cargar_datos_municipios () {
      const result = options.b.filter((o) =>
        matchFilterKey(o.filterKey, this.model, 1)
      );
      if (result.length === 1) {
        this.model.b = result[0].value;
      } // <- this smells!
      return result;
    },

    isNew () {
      if (this.isLoading) return false;
      if (this.data.envioId) {
        return false;
      }
      return true;
    },
    envioTitulo () {
      if (this.isNew) {
        return 'Nuevo envío';
      }
      return 'Envío';
    },
    getSaveLabel () {
      if (this.isNew) return 'crear';
      return 'guardar';
    },
    isBusy () {
      if (this.isLoading) return true;
      if (this.isSending) return true;
      return false;
    }
  },

  data: function () {
    return {
      framework: {
        // NOT needed if using auto-import feature:
        components: ['QDialog', 'QTable'],
        // NOT needed if using auto-import feature:
        directives: ['ClosePopup'],
        plugins: ['Loading'],
        config: {
          loading: {
            /* Loading defaults */
          }
        }
      },

      Datos_Generales: {
        Nombre: '',
        ProvinciaId: 0,
        MunicipioId: 0,

        NivelFreatico: false,
        Trafico: false,
        MaterialId: 0,
        TerrenoId: 0,
        PavimentoId: 0,
        TerrenoId: 0,
        ProfundidadMedia: 0,
        Acometidas: 0,
        PozosRegistro: 0,
        Incidencias: 0,
        Id: 0
      },

      Datos_Decision: {
        ServicioId: 0,
        ActuacionId: 0,
        ProblemaId: 0
      },

      Datos_Tramo: [],

      filteredTitulares: [],
      isLoading: false,
      isSending: false,
      isAdmin: 0,
      isLoadingDatos: false,
      enums: {},

      tipo: null,
      datos_provincias: [],
      datos_provinciasSelect: [],
      datos_municipios: [],
      datos_municipiosSelect: [],
      datos_servicios: [],
      datos_actuaciones: [],
      datos_problemas: [],
      datos_tramos: [],
      datos_diametro: [],
      datos_material: [],
      datos_terreno: [],
      datos_pavimento: [],

      tecnologia: '....',

      /* usuario: "", */
      aplicacion: null,
      mail: '',
      nombre_actuacion: '',
      provincia: null,
      municipio: null,

      servicio: null,
      actuacion: null,
      problema: null,

      diametro: null,
      longitud: null,
      multitramo: false,
      url: null,

      isSaneamiento: true,
      disable_tramos: true,
      alert_tramos: false,
      mensaje_alert: '',
      mensaje_cargando: '',

      presupuestoID: null,

      nivel_freatico: false,
      trafico: false,
      material: null,
      terreno: null,
      pavimento: null,
      profundidad_media: null,
      acometida: null,
      pozo_registro: null,
      incidencias: null,

      editedIndex: -1,
      editedItem: {
        datotramo_Longitud: 0,
        datotramo_Diametro: 0,
        datotramo_Id: 0
      },

      datos_pruebas: [{ Longitud: 22, Diametro: 1000 }],

      columns: [
        {
          field: (row) => row.name,
          format: (val) => `${val}`,
          name: 'Longitud',
          align: 'center',
          label: 'Longitud (m)',
          field: 'datotramo_Longitud',
          style: 'width:30%',
          sortable: true
        },
        {
          name: 'Diametro',
          label: 'Diámetro (mm)',
          field: 'datotramo_Diametro',
          sortable: true,
          style: 'width:30%'
        },

        {
          name: 'actions',
          label: '.',
          field: 'actions',
          style: 'width:30%'
        }
      ]
    };
  },
  validations: {
    nombre_actuacion: { required },
    /* nombre_actuacion: function(){
        let txt = this.nombre_actuacion;

        console.log(txt);

        return required;
      }, */
    provincia: { required },
    municipio: { required },
    servicio: { required },
    actuacion: { required },
    problema: { required },
    material: { required },
    terreno: { required },
    pavimento: { required },
    profundidad_media: { required },
    acometida: { required },
    // POZOS
    incidencias: { required },
    longitud: function () {
      if (this.isSaneamiento) {
        return required;
      }
    }
  },

  components: {
    QInput,
    QSelect,
    QCard,
    QList,
    QField,
    QCardSection,
    QCardActions,
    QBtnToggle,
    QCheckbox,
    QTable,
    QTh,
    QTr,
    QTd,
    QToggle,
    ClosePopup,
    QDialog,
    QSpinnerGears,
    Cargando
  }
};
</script>
<style lang="scss" scoped>
$azulHover: #225eac;
$azuloscuro: #002f6c;
$azuloclaro: #878b97;

.buttonoscuro {
  background-color: $azuloscuro !important;
  border: none;
  color: #fff;
  font-weight: bold;
  line-height: 1.14;
  letter-spacing: 1.25px;
  font-size: 14px;
  &:hover {
    background-color: $azulHover !important;
    color: #fff;
  }
}

.buttonclaro {
  border: 1px solid #002f6c;
  color: #002f6c;
  font-weight: bold;
  line-height: 1.14;
  letter-spacing: 1.25px;
  font-size: 14px;
  &:hover {
    background-color: $azuloscuro !important;
    color: #fff;
  }
}

.buttonoscurodisabled {
  opacity: 0.18;
  border-radius: 4px;
  background-color: #979797;
  color: $azuloscuro;
  font-weight: bold;
  line-height: 1.14;
  letter-spacing: 1.25px;
  font-size: 14px;
}
</style>
